export const SubmitSearchButtonId = 'submit_search_button';
